package ru.chm.gradereport.ui.components

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.scrollBy
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import ru.chm.gradereport.ui.theme.GradeTheme
import kotlin.math.roundToInt

@Composable
fun HorizontalScrollBar(
    scrollState: ScrollState,
    modifier: Modifier = Modifier,
) {
    val max = scrollState.maxValue
    if (max <= 0) return

    val scope = rememberCoroutineScope()
    val density = LocalDensity.current
    val trackColor = GradeTheme.colors.scrollTrack
    val thumbColor = GradeTheme.colors.scrollThumb

    BoxWithConstraints(
        modifier = modifier
            .fillMaxWidth()
            .height(14.dp)
            .clip(RoundedCornerShape(999.dp))
            .background(trackColor)
            .pointerInput(scrollState, max) {
                detectTapGestures { offset ->
                    val track = size.width.toFloat().coerceAtLeast(1f)
                    val ratio = (offset.x / track).coerceIn(0f, 1f)
                    scope.launch { scrollState.scrollTo((max * ratio).roundToInt()) }
                }
            },
        contentAlignment = Alignment.CenterStart,
    ) {
        val trackPx = with(density) { maxWidth.toPx() }.coerceAtLeast(1f)
        val contentPx = trackPx + max
        val thumbFraction = (trackPx / contentPx).coerceIn(0.12f, 1f)
        val thumbPx = (trackPx * thumbFraction).coerceAtLeast(with(density) { 28.dp.toPx() })
        val travelPx = (trackPx - thumbPx).coerceAtLeast(0f)
        val thumbOffsetPx = if (max == 0) 0f else travelPx * scrollState.value / max

        Box(
            modifier = Modifier
                .offset { IntOffset(thumbOffsetPx.roundToInt(), 0) }
                .width(with(density) { thumbPx.toDp() })
                .height(14.dp)
                .clip(RoundedCornerShape(999.dp))
                .background(thumbColor)
                .pointerInput(scrollState, max, travelPx) {
                    detectHorizontalDragGestures { _, dragAmount ->
                        if (travelPx <= 0f) return@detectHorizontalDragGestures
                        val deltaScroll = dragAmount / travelPx * max
                        scope.launch { scrollState.scrollBy(deltaScroll) }
                    }
                },
        )
    }
}
